'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../node_modules/classnames/index.js');
require('./Accordion.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Accordion = function (_a) {
    var title = _a.title, content = _a.content;
    var _b = React.useState(false), collapse = _b[0], setCollapse = _b[1];
    return (React__default['default'].createElement("div", { className: 'accordion' },
        React__default['default'].createElement("div", { className: 'accordion__head' },
            React__default['default'].createElement("div", { className: 'accordion__title', onClick: function () { return setCollapse(!collapse); } },
                React__default['default'].createElement("i", { className: index['default']('mr-2 icon', "" + (collapse ? 'lifepal-arrow-up' : 'lifepal-arrow-down')) }),
                React__default['default'].createElement("div", null, title))),
        React__default['default'].createElement("div", { className: 'accordion__body' },
            React__default['default'].createElement("div", { className: index['default'](collapse ? 'accordion__content--show' : '', 'accordion__content') },
                " ",
                content,
                " "))));
};

exports.Accordion = Accordion;
//# sourceMappingURL=Accordion.js.map
